/**
 * BarChart7d — simple 7-day volume bar chart. Uses `recharts` (in deps) with a
 * signature-gradient fill. Falls back gracefully to a calm, branded look.
 */
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  XAxis,
} from "recharts";
import type { DayCount } from "@/types/voice-vision";

interface BarChart7dProps {
  data: DayCount[];
  height?: number;
  className?: string;
}

export const BarChart7d = ({ data, height = 170, className }: BarChart7dProps) => {
  const gradientId = "voice-bar-7d";
  return (
    <div className={className} style={{ width: "100%", height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 4, bottom: 0, left: 4 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4E9CFF" />
              <stop offset="100%" stopColor="#FF4DB8" />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="day"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#9CA3AF", fontSize: 11.5 }}
          />
          <Bar dataKey="count" radius={[8, 8, 8, 8]} maxBarSize={34}>
            <LabelList
              dataKey="count"
              position="top"
              style={{ fill: "#64748B", fontSize: 11.5, fontWeight: 700 }}
            />
            {data.map((entry) => (
              <Cell key={entry.day} fill={`url(#${gradientId})`} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart7d;
